<script>
  export let content=true;
</script>

<footer
  class="w-full mx-auto text-gray-700 body-font bottom-0 py-2">
  <div
    class="max-w-screen-xl px-5 py-1 mx-auto flex items-center justify-between">
    <div
      class="lg:w-3/6 md:3/6 w-full text-sm text-gray-700 font-light sm:py-2 sm:mt-0 mt-4  lg:block hidden">
      <div>
        {#if content}
        <img
          src="./assets/logo/logo.svg" width="140" height="35"
          class="h-8 bg-white shadow rounded-lg my-2"
          alt="Dekatan" />
        <h6 class="inline-block">Dekatan</h6>
        <span> merupakan situs yang menghubungkan warga desa dengan kemudahan
          Belanja, Berjualan dan melakukan tugas Pengiriman dalam satu aplikasi
          <br /><br /></span>
          {/if}
          <span class="text-gray-700 ml-1">© 2021 Dekatan —
          PT. Rakit Solutions Indonesia</span>
      </div>
    </div>
    <div class="lg:w-3/6 md:3/6 w-full flex lg:justify-end justify-center mt-0">
      <i class="text-xs font-hairline">version 1.0.0</i>
    </div>
  </div>
</footer>
